import React from "react";

import numeral from "numeral";
import filter from "lodash/filter";
import { connect } from "react-redux";

import { PAGES } from "../../config/constants";
import { FIX_FLIP } from "../../constants/typeOfHomeOptions";
import pms_lien_position from "../../constants/pms_lien_position";
import { MORTGAGE_BROKER } from "../../constants/contact_id_status";

import { saveToCRM } from "../../actions/saveToCRM.actions";

const LoanSummary = (props) => {
  const {
    purchase_price,
    loan_amount,
    lien_position,
    broker_points,
    broker_processing_fee_5,
    id_status,
    setPrevPage,
    as_is_value,
    arv_market_value,
    type_of_loan,
  } = props;

  const _lien_position = filter(pms_lien_position, { value: lien_position })[0];

  return (
    <div className="row">
      <div className="col-md-10 offset-md-1">
        <div className="card">
          <div className="card-header">
            <h3>Summary</h3>
          </div>
          <div className="card-body">
            <ul className="list-group">
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">Value</div>
                  <div className="col-md-6">Value</div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">Purchase Price</div>
                  <div className="col-md-6">
                    {numeral(purchase_price).format("$0,0.00")}
                  </div>
                </div>
              </li>
              <br />
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">Loan Amount</div>
                  <div className="col-md-6">
                    {numeral(loan_amount).format("$0,0.00")}
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">Lien Position</div>
                  <div className="col-md-6">{_lien_position.name}</div>
                </div>
              </li>
              <br />
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">LTP</div>
                  <div className="col-md-6">
                    {numeral(loan_amount / purchase_price).format("0.00%")}
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="row">
                  <div className="col-md-6">LTV</div>
                  <div className="col-md-6">
                    {numeral(loan_amount / as_is_value).format("0.00%")}
                  </div>
                </div>
              </li>

              {type_of_loan === FIX_FLIP.value && (
                <li className="list-group-item">
                  <div className="row">
                    <div className="col-md-6">LTV - ARV</div>
                    <div className="col-md-6">
                      {numeral(loan_amount / arv_market_value).format("0.00%")}{" "}
                      %
                    </div>
                  </div>
                </li>
              )}

              {id_status === MORTGAGE_BROKER.value && (
                <React.Fragment>
                  <br />
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-md-6">Broker Points</div>
                      <div className="col-md-6">{broker_points} %</div>
                    </div>
                  </li>
                  <li className="list-group-item">
                    <div className="row">
                      <div className="col-md-6">Broker Processing</div>
                      <div className="col-md-6">
                        {broker_processing_fee_5} %
                      </div>
                    </div>
                  </li>
                </React.Fragment>
              )}
            </ul>

            <div style={{ marginTop: 10 }}>
              <div style={{ float: "left" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-green"
                  onClick={setPrevPage}
                >
                  Back
                </button>
              </div>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-green"
                  onClick={props.submitData}
                >
                  Submit Loan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapState = (state) => {
  return {
    purchase_price: state.consoleBrok1.purchase_price,
    loan_amount: state.consoleBrok1.loan_amount,
    lien_position: state.consoleBrok1.lien_position,
    broker_points: state.consoleBrok1.broker_points,
    broker_processing_fee_5: state.consoleBrok1.broker_processing_fee_5,
    id_status: state.form.contacts.id_status,
    as_is_value: state.consoleBrok1.as_is_value,
    arv_market_value: state.consoleBrok1.arv_market_value,
    type_of_loan: state.form.accounts.type_of_loan,
  };
};

const mapDispatch = (dispatch) => {
  return {
    setPrevPage: () => {
      dispatch({
        type: "SET_PAGE",
        payload: PAGES.CONSOLE_BROOK_4,
      });
    },

    submitData: () => {
      dispatch(saveToCRM());
    },
  };
};

export default connect(mapState, mapDispatch)(LoanSummary);



// WEBPACK FOOTER //
// ./src/Screens/LoanSummary/index.js